import { useGetCurrentUserQuery } from 'services';

export const useIsUnverified = () => {
	const { data } = useGetCurrentUserQuery();

	return data && data.is_verified === false;
};
